import React from 'react'
import { PolicyTosContainer } from '../../../components/policy-tos-container'
import { useAppContext } from '../../../hooks/useAppContext'

export const Page = () => {
  const {
    routeContext: { title, content },
  } = useAppContext()

  return <PolicyTosContainer content={content} title={title} />
}

export default Page
